import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export const CouponImportAccessRights = {
  VIEW_COUPON_IMPORT: ({ menuDisplayLevel }) =>
    menuDisplayLevel === 0 ||
    menuDisplayLevel === 1 ||
    menuDisplayLevel === 2 ||
    menuDisplayLevel === 4,
} satisfies Record<string, AuthenticationAccessRight>;
